function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.044,
  cy: 16.929,
  r: 15,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10.168,
  y: 10.324,
  stroke: "currentColor",
  rx: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 18.355,
  y: 10.324,
  stroke: "currentColor",
  rx: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 10.168,
  y: 18.305,
  stroke: "currentColor",
  rx: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 18.355,
  y: 18.305,
  stroke: "currentColor",
  rx: 0.5
});

function SvgAppstoreWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstoreWhite);
export default __webpack_public_path__ + "static/media/appstore-white.2b834a18.svg";
export { ForwardRef as ReactComponent };